<h1 class="save-line-head" i18n='@@title-Configuration'>Configurazione</h1>

<div class="menu-row">
  <a routerLink="solutions" class="menu-link">
    <mat-card class="menu-card">
      <div class="menu-content">
        <mat-icon svgIcon="light-bulb" class="start-icon"></mat-icon>
        <span class="label" i18n='@@title-Solutions'>Soluzioni</span>
        <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
      </div>
    </mat-card>
  </a>

  <a routerLink="payment-methods" class="menu-link">
    <mat-card class="menu-card">
      <div class="menu-content">
        <mat-icon svgIcon="credit-card" class="start-icon"></mat-icon>
        <span class="label" i18n='@@title-PaymentMethods'>Metodi di pagamento</span>
        <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
      </div>
    </mat-card>
  </a>
</div>
